class HotSpotQuestionStrategy {
    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;
        this.mediaContainer = null;
        this.questionContainer = null;
        this.correct_answer = null;
        this.answer_2 = null;
        this.answer_3 = null;
        this.answer_4 = null;
        this.images = [];

        var that = this;
        $(".showImageBtn").click(function(event) {
            event.stopPropagation();

            $('#myModalMM').show();

            var modalImg = document.getElementById("img01");
            modalImg.src = that.playScreenController.currentQuestion.multimedia;

            let $container = $('#modal-image-container');
            let containerW = $container.width();
            let containerH = $container.height();
            let containerAspectRatio = containerW / containerH;

            let $img = $('#img01');
            let imgW = $img[0].naturalWidth;
            let imgH = $img[0].naturalHeight;
            let imgApectRatio = imgW / imgH;

            let fitSize = (containerAspectRatio > imgApectRatio) ? [imgW * containerH/imgH, containerH] : [containerW, imgH * containerW/imgW];
            $('#hotspot-zoom-image-container, #img01').css({
                'width': fitSize[0]-2,
                'height': fitSize[1]-2,
                'max-width': fitSize[0]-2,
                'max-height': fitSize[1]-2
            });

            var span = document.getElementsByClassName("close")[0];
            span.onclick = function() {
                $('#myModalMM').hide();
            };

            return false;
        });

        $('#questionContainer').on("click", '.img-v-container, #img01', function(event) {
            event.stopPropagation();
            $('#myModalMM').hide('fast');
            $('[default_false_trigger="true"]').trigger('click',true);
            return false;
        });

        $('#modal-image-container').on("click", '.answerBtn[data-launch-answer="true"]', function(event) {
            event.stopPropagation();
            $('#myModalMM').hide('fast');
            $('.answerBtn[data-launch-answer="false"][data-answer="'+$(this).attr('data-answer')+'"]').trigger('click',false);
            return false;
        });
    };

    draw() {

        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');
        this.images = [this.playScreenController.currentQuestion.multimedia];
        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_HOTSPOT"]).appendTo(this.mediaContainer);
        this.correct_answer = this.playScreenController.currentQuestion.correct_answer;
        this.answer_2 = this.playScreenController.currentQuestion.answer_2;
        this.answer_3 = this.playScreenController.currentQuestion.answer_3;
        this.answer_4 = this.playScreenController.currentQuestion.answer_4;

        if (this.correct_answer && !this.answer_2 && !this.answer_3 && !this.answer_4) {
            $('.img-responsive-v, #img01').css('cursor', 'pointer').on("click",  function() {
                $('#hotSpotOtherBtn').trigger('click',false);
            });

            if(!$('#simplifyWildcardLink').hasClass('disabled-link')) {
                $('#simplifyWildcardLink').find('img').attr('src', '/images/simplificar.png');
                $('#simplifyWildcardLink').addClass('disabled-link locked-simplify');
                $('#simplifyWildcardSection').find('p').removeClass('black-text');

                $('#simplifyWildcardLink').unbind("click");
            }
        }

        if (this.correct_answer) {
            $('.img-v-container').append(this.createHotSpot(this.correct_answer.split(','),false,false));
            $('#hotspot-zoom-image-container').append(this.createHotSpot(this.correct_answer.split(','),false,true));
        }
        if (this.answer_2) {
            $('.img-v-container').append(this.createHotSpot(this.answer_2.split(','),true,false));
            $('#hotspot-zoom-image-container').append(this.createHotSpot(this.answer_2.split(','),false,true));
        }
        if (this.answer_3) {
            $('.img-v-container').append(this.createHotSpot(this.answer_3.split(','),false,false));
            $('#hotspot-zoom-image-container').append(this.createHotSpot(this.answer_3.split(','),false,true));
        }
        if (this.answer_4) {
            $('.img-v-container').append(this.createHotSpot(this.answer_4.split(','),false,false));
            $('#hotspot-zoom-image-container').append(this.createHotSpot(this.answer_4.split(','),false,true));
        }

        $('body').addClass('stop-scrolling');

        this.questionContainer.css('min-height', '');

        var img = new Image();
        img.onload = () => {
            this.questionContainer = null;
            this.preload();
        }
        img.onerror = () => {
             console.warn("Error loading hotspot image");
             this.questionContainer = null;
             this.preload();
        }
        img.src = $(".img-responsive-v").attr('src');

        $(".answerBtn").on("click", function () {
            $("html").css('overflow', 'visible');
        });
    };

    preload() {
        if (this._cancelled) return;

        $(this.images).each(function() {
            $('<img/>')[0].src = this;
        });

        $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        $(".question-color-wrapper").show();

        this._preloadTimeout = setTimeout(this.startTime.bind(this), 1000);

    };

    startTime() {
        this.hideImage();
        $(".question-color-wrapper").hide();
        this.playScreenController.startTimer(this.result);
    };

    hideImage() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.mediaContainer.slideUp();
        $('body').removeClass('stop-scrolling');
    };

    createHotSpot(coord,default_false,launch_answer) {

        let clase = (this.answer_2 || this.answer_3 || this.answer_4) ? 'hot-spot-div' : 'hot-spot-hidden-div';
        // world.show_hot_spots ? clase = 'hot-spot-div' : clase = 'hot-spot-hidden-div';

        let hotSpot = $('<div>', {
            'class': clase + ' answerBtn',
            'data-answer': coord.join(),
            'data-default-trigger': default_false,
            'data-launch-answer': launch_answer,
            'css': {
                'border-color': '#' + this.playScreenController.currentQuestion.category.color,
                'width': coord[2] - coord[0] + '%',
                'height': coord[3] - coord[1] + '%',
                'left': coord[0] + '%',
                'top': coord[1] + '%',
                'background-color': 'rgba(0,0,0,0)'
            }
        });

        return hotSpot;
    }

    cancel() {
        this._cancelled = true;
        clearTimeout(this._preloadTimeout);
    }

    onCompleteTime() {
        $('#myModalMM').hide('fast');
    }
}